import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const formatMoney = (amount, currency, lang) =>
  new Intl.NumberFormat(lang, { style: "currency", currency: (currency || "eur").toUpperCase() }).format(amount ?? 0);
